import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loading: false,
  error: {},
});

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    LOADING: (s) => Object.assign(s, initState(), { loading: true }),
    SET_ERROR: (s, error) => (s.error = error),
    LOADED: (s) => (s.loading = false),
    RESET: (s) => Object.assign(s, initState()),
  },

  actions: {
    // GET tỉ giá chung hiện tại (dùng cho placeholder). Nuốt lỗi → trả null để FE fallback.
    async getSystemExchangeRate() {
      try {
        const res = (await this.$api.get(`/v1/cms/exchange-rate/system`))?.data
          ?.data;
        return res || null;
      } catch (e) {
        return null;
      }
    },

    // PUT cập nhật tỉ giá chung cho toàn hệ thống.
    async updateSystemExchangeRate({ commit }, payload) {
      commit("LOADING");
      try {
        const res = (
          await this.$api.put(`/v1/cms/exchange-rate/system`, payload)
        )?.data?.data;
        if (res) {
          return res;
        }
        throw new Error();
      } catch (e) {
        errorHandler("Cập nhật tỉ giá chung thất bại!");
      } finally {
        commit("LOADED");
      }
    },
  },
};
